<template>
  <v-navigation-drawer
    class="menu rounded"
    v-model="$store.state.drawer"
    right
    app
  >
    <v-list dense class="pt-0">
      <v-list-item style="background-color: #9c27b0c7">
        <v-list-item-content>
          <h3 class="white--text mb-0">
            <v-icon large color="white">mdi-account-outline</v-icon>
            {{ $store.state.suppliers_user.name }}
          </h3>
          <p class="mb-0 white--text ms-10 font-weight-bold">
            {{ $store.state.suppliers_user.phone_number }}
          </p>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        active-class="primary white--text"
        v-for="item in links"
        :key="item.title"
        link
        :to="{ name: item.link }"
      >
        <v-list-item-icon class="me-2">
          <v-icon style="font-size: 18px">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">{{
            item.title
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item active-class="primary white--text" @click="logout()">
        <v-list-item-icon class="me-2">
          <v-icon style="font-size: 18px">logout</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            {{ trans("menu", "logout") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  data() {
    return {
      drawer: true,
      mini: false,
      isMobile: true,
    };
  },

  computed: {
    links() {
      let links = [
        {
          title: this.trans("menu", "dashboard"),
          icon: "mdi-view-dashboard-outline",
          link: "dashboard",
          permission: "dashboard access",
        },
        {
          title: this.trans("menu", "ordersActivities"),
          icon: "mdi-cart-outline",
          link: "ordersActivities",
          permission: "orders edit",
        },
        {
          title: this.trans("menu", "orders"),
          icon: "mdi-cart-outline",
          link: "orders",
          permission: "orders access",
        },

        {
          title: 'compensations',
          icon: "mdi-cart-outline",
          link: "compensations",
          permission: "orders access",
        },

        {
          title: this.trans("menu", "products"),
          icon: "mdi-inbox-outline",
          link: "products",
          permission: "products access",
        },
        {
          title: this.trans("menu", "categories"),
          icon: "mdi-shape-outline",
          link: "categories",
          permission: "categories access",
        },

        {
          title: this.trans("menu", "payments"),
          icon: "mdi-sack-outline",
          link: "payments",
          permission: "payments access",
        },

        {
          title: this.trans("menu", "banners"),
          icon: "mdi-image-outline",
          link: "banners",
          permission: "banners access",
        },

        {
          title: this.trans("menu", "boxes"),
          icon: "mdi-view-grid-outline",
          link: "boxes",
          permission: "boxes access",
        },

        {
          title: this.trans("menu", "brands"),
          icon: "mdi-bookmark-box-outline",
          link: "brands",
          permission: "brands access",
        },
        {
          title: this.trans("menu", "customers"),
          icon: "mdi-account-group-outline",
          link: "customers",
          permission: "customers access",
        },
        {
          title: this.trans("menu", "prices"),
          icon: "mdi-sale-outline",
          link: "prices",
          permission: "prices access",
        },
        {
          title: this.trans("menu", "ownCities"),
          icon: "mdi-home-city-outline",
          link: "ownCities",
          permission: "cities access",
        },
        {
          title: this.trans("menu", "employees"),
          icon: "mdi-account-supervisor-outline",
          link: "employees",
          permission: "employees access",
        },
        {
          title: this.trans("menu", "coupons"),
          icon: "mdi-ticket-percent-outline",
          link: "coupons",
          permission: "coupons access",
        },
        {
          title: this.trans("menu", "SettingsNav"),
          icon: "mdi-cog-outline",
          link: "SettingsNav",
          permission: "settings access",
        },
      ];
      let permissiosn = this.$store.state.userPermissions;
      return links.filter((f) => permissiosn.includes(f.permission));
    },
  },

  methods: {
    logout() {
      this.$store.dispatch("logout");

    },
  },
  created() {
    // let app = this;
    // window.addEventListener("load", function (e) {
    //   if (e.currentTarget.outerWidth <= 991) {
    //     app.isMobile = true;
    //   } else {
    //     app.isMobile = true;
    //   }
    // });
    // window.addEventListener("resize", function (e) {
    //   if (e.currentTarget.outerWidth <= 991) {
    //     app.isMobile = true;
    //   } else {
    //     app.isMobile = true;
    //   }
    // });
  },
};
</script>
